import { css } from '@emotion/react';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';

type BreakdownYearContainerProps = {
  title?: string | React.ReactNode | number;
  children?: React.ReactNode;
  pb?: number | string;
} & Omit<React.ComponentProps<typeof Box>, 'title'>;

const BreakdownYearContainer = ({
  title,
  children,
  pb,
  ...props
}: Readonly<BreakdownYearContainerProps>) => {
  return (
    <Box
      role="region"
      aria-label={
        typeof title === 'string' || typeof title === 'number'
          ? String(title)
          : undefined
      }
      border="1px solid"
      borderRadius={4}
      borderColor="gray.200"
      {...props}
    >
      <Box bgColor="gray.50" borderTopRadius={4} h="40px" p={2} px={4}>
        <Text fontWeight={500} fontSize="lg">
          {title}
        </Text>
      </Box>
      <Box
        display="inline-block"
        minW="40%"
        p={5}
        pb={pb || 0}
        css={css`
          & > div {
            width: 100%;
            clear: both;
            float: left;
            margin-bottom: 1rem;
          }
        `}
      >
        {children}
      </Box>
    </Box>
  );
};

export default BreakdownYearContainer;
